import { object } from 'underscore'
import i18n from '@/configuration/I18nConfiguration'

export const getFieldsProperties = (value, isPlaceholder) => {
  return object([
    ['pan', value],
    ['expiryDate', value],
    ['securityCode', value],
    ['pocketType', value],
    isPlaceholder
      ? [
          'installmentNumber',
          {
            default: value,
            singlePayment: value,
            singlePaymentCredit: value
          }
        ]
      : ['installmentNumber', value],
    ['firstInstallmentDelay', value],
    ['identityDocumentType', value],
    ['identityDocumentNumber', value],
    ['cardHolderName', value],
    ['cardHolderMail', value],
    ['doRegister', value]
  ])
}

export const getI18nProperties = value => {
  const langs = i18n.supportedLocales
  return langs.reduce((acc, lang) => {
    acc[lang] = value
    return acc
  }, {})
}

export const getContentLabelFields = value => {
  return {
    installmentNumber: {
      singular: value,
      plural: value
    },
    firstInstallmentDelay: {
      singular: value,
      plural: value
    }
  }
}
